var rich_content_viewer_default = {
  "fontElementMap": "n-Vc-",
  "wrapper": "eD-5P",
  "pluginContainerMobile": "lnFDW",
  "viewer": "Wduxs",
  "android": "qdY4H",
  "rootedTraversedContent": "IelL6",
  "atomic": "_1PN-D",
  "toolbar": "UF1Z3",
  "block": "Qhg38"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
